<template>
    <ClientOnly>
        <Vue3Lottie :animationData="ZapoLogoJson" :height="dim" :width="dim" :loop="true" :noMargin='true' />
    </ClientOnly>
</template>

<script>
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'

export default {
    props: {
        dim: {
            type: Number,
            default: 40
        }
    },

    data() {
        return {
            ZapoLogoJson,
        }
    }
}
</script>